"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageUploadReader = exports.FileUploadReader = exports.UniversalFileUploadReader = void 0;
exports.validateImageFile = validateImageFile;
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const services_1 = require("../services");
const image_compression_1 = require("./image.compression");
const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/jpg'];
const MAX_IMAGE_SIZE = 1024 * 1024 * 10; // 10 Megabyte
function validateImageFile(file) {
    if (file.size > MAX_IMAGE_SIZE) {
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'image:large', 'large', file.size);
        return 'FILE_TOO_LARGE';
    }
    const imageType = file.type.toLowerCase();
    if (!ALLOWED_IMAGE_TYPES.includes(imageType)) {
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Upload, 'image:type', imageType || 'unknown', 1);
        return 'FILE_NOT_SUPPORTED';
    }
    return null;
}
class UniversalFileUploadReader {
    constructor(file, field) {
        this.file = file;
        this.buffer = null;
        this.isFailed = false;
        this.isLoading = true;
        this.name = file.name;
        this.type = file.type;
        this.size = file.size;
        this.field = field;
        this.fileReader = new FileReader();
        this.fileReader.onerror = this.onFileError;
        this.fileReader.onload = this.onFileLoad;
        this.fileReader.readAsArrayBuffer(file);
    }
    onFileError() {
        var _a;
        (_a = this.fileReader) === null || _a === void 0 ? void 0 : _a.abort();
        this.isFailed = true;
        this.isLoading = false;
    }
    onFileLoad() {
        var _a;
        this.isFailed = false;
        this.isLoading = false;
        if (((_a = this.fileReader) === null || _a === void 0 ? void 0 : _a.result) && this.fileReader.result instanceof ArrayBuffer) {
            this.buffer = new Uint8Array(this.fileReader.result);
        }
        this.fileReader = null;
    }
}
exports.UniversalFileUploadReader = UniversalFileUploadReader;
tslib_1.__decorate([
    mobx_1.observable
], UniversalFileUploadReader.prototype, "buffer", void 0);
tslib_1.__decorate([
    mobx_1.observable
], UniversalFileUploadReader.prototype, "isFailed", void 0);
tslib_1.__decorate([
    mobx_1.observable
], UniversalFileUploadReader.prototype, "isLoading", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], UniversalFileUploadReader.prototype, "onFileError", null);
tslib_1.__decorate([
    mobx_1.action.bound
], UniversalFileUploadReader.prototype, "onFileLoad", null);
class FileUploadReader extends UniversalFileUploadReader {
}
exports.FileUploadReader = FileUploadReader;
class ImageUploadReader extends UniversalFileUploadReader {
    constructor(file, field) {
        super(file, field);
        // Override parent's onload to compress instead of using raw data
        if (this.fileReader) {
            this.fileReader.onload = () => this.compressAndLoad(file);
        }
    }
    compressAndLoad(file) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                // Compress the image using browser-image-compression library
                this.buffer = yield image_compression_1.ImageCompression.compressImage(file, {
                    quality: 0.95,
                });
                this.isFailed = false;
                this.isLoading = false;
            }
            catch (error) {
                services_1.Services.Log.Logger.warn({ error }, 'Image compression failed, uploading original');
                // Fallback: read the original file with FileReader
                const fallbackReader = new FileReader();
                fallbackReader.onload = () => {
                    if (fallbackReader.result && fallbackReader.result instanceof ArrayBuffer) {
                        this.buffer = new Uint8Array(fallbackReader.result);
                    }
                    this.isFailed = false;
                    this.isLoading = false;
                };
                fallbackReader.onerror = () => {
                    this.isFailed = true;
                    this.isLoading = false;
                };
                fallbackReader.readAsArrayBuffer(file);
            }
        });
    }
}
exports.ImageUploadReader = ImageUploadReader;
tslib_1.__decorate([
    mobx_1.action.bound
], ImageUploadReader.prototype, "compressAndLoad", null);
//# sourceMappingURL=upload.reader.js.map